module.exports = __webpack_public_path__ + "static/media/presentation.70ed8e4a.svg";